<template>
  <div class="sales-reports-page-header mb-3">
    <div class="d-flex flex-wrap align-items-start justify-content-between">
      <div class="header-main">
        <nav
          v-if="breadcrumbs.length"
          class="lov-breadcrumb mb-2"
        >
          <span
            v-for="(crumb, index) in breadcrumbs"
            :key="index"
            class="lov-breadcrumb-item"
          >
            <i
              v-if="index === 0"
              class="fas fa-home mr-1"
            />
            {{ crumb }}
            <span
              v-if="index < breadcrumbs.length - 1"
              class="lov-breadcrumb-sep"
            >›</span>
          </span>
        </nav>
        <div class="d-flex align-items-center flex-wrap">
          <h5 class="header-title mb-0">{{ title }}</h5>
          <span
            v-if="apiPath"
            class="api-badge ml-2"
          >{{ apiMethod }} {{ apiPath }}</span>
        </div>
        <p
          v-if="subtitle"
          class="header-subtitle mb-0 mt-1"
        >
          {{ subtitle }}
        </p>
      </div>
      <div class="header-actions d-flex mt-2 mt-md-0">
        <b-button
          size="sm"
          variant="outline-secondary"
          class="btn-lov-outline mr-2"
          :disabled="loading"
          @click="$emit('refresh')"
        >
          <i class="fas fa-sync-alt mr-1" />
          Làm mới
        </b-button>
        <b-button
          v-if="showExport"
          size="sm"
          variant="success"
          class="btn-lov-export"
          :disabled="loading || !canExport"
          @click="$emit('export')"
        >
          <i class="fas fa-download mr-1" />
          Xuất Excel
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SalesReportsPageHeader',
  props: {
    title: { type: String, default: '' },
    apiPath: { type: String, default: '' },
    apiMethod: { type: String, default: 'GET' },
    subtitle: { type: String, default: '' },
    loading: { type: Boolean, default: false },
    canExport: { type: Boolean, default: false },
    showExport: { type: Boolean, default: true },
    breadcrumbs: {
      type: Array,
      default: () => ['Báo cáo', 'Báo cáo bán hàng'],
    },
  },
};
</script>

<style scoped>
.header-title {
  font-weight: 700;
  color: #111827;
}
.api-badge {
  font-size: 11px;
  font-weight: 500;
  color: #2563eb;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 6px;
  padding: 2px 8px;
  font-family: ui-monospace, monospace;
}
.header-subtitle {
  font-size: 13px;
  color: #6b7280;
}
.lov-breadcrumb {
  font-size: 12px;
  color: #9ca3af;
}
.lov-breadcrumb-item {
  display: inline;
}
.lov-breadcrumb-sep {
  margin: 0 6px;
  color: #d1d5db;
}
.btn-lov-outline {
  border-radius: 8px;
  font-weight: 500;
}
.btn-lov-export {
  border-radius: 8px;
  font-weight: 500;
  background: #16a34a;
  border-color: #16a34a;
}
</style>
